import React from 'react';
import { useTutorial } from '../../contexts/TutorialContext';
import styles from './TutorialOverlay.module.css';

interface TutorialOverlayProps {
  children: React.ReactNode;
}

const TutorialOverlay: React.FC<TutorialOverlayProps> = ({ children }) => {
  const { shouldShowWelcome, dismissWelcome } = useTutorial();

  return (
    <>
      {children}
      {shouldShowWelcome && (
        <div className={styles.backdrop} onClick={dismissWelcome}>
          <div className={styles.popup} onClick={e => e.stopPropagation()}>
            <div className={styles.crest}>⚔</div>
            <h2 className={styles.title}>Welcome to Njordheim</h2>
            <p className={styles.intro}>
              Your mercenary has been created. Here are a few things to get you started:
            </p>
            <ul className={styles.tips}>
              <li>
                <span className={styles.tipIcon}>📖</span>
                <span>The <strong>Game Guide</strong> is available in the <strong>bottom-left corner</strong> it covers all game mechanics in detail.</span>
              </li>
              <li>
                <span className={styles.tipIcon}>⚔</span>
                <span>Click the <strong>Battle</strong> link in the left menu to send your mercenary into combat.</span>
              </li>
              <li>
                <span className={styles.tipIcon}>👤</span>
                <span>Click your <strong>avatar portrait</strong> in the right panel to view your mercenary's stats, inventory, advancements, and finances.</span>
              </li>
              <li>
                <span className={styles.tipIcon}>💰</span>
                <span>Visit the <strong>Market</strong> to buy equipment and gear up your mercenary.</span>
              </li>
            </ul>
            <button className={styles.dismissBtn} onClick={dismissWelcome}>
              Begin your journey
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TutorialOverlay;
